import { render } from "./ProfileAgenda.view.vue?vue&type=template&id=206a4a15"
import script from "./ProfileAgenda.view.vue?vue&type=script&lang=js"
export * from "./ProfileAgenda.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__